export enum HistoryActionEnum {
    DraftDataReqCreated = 'DraftDataReqCreated',
    DraftDataReqSubmittedToVivli = 'DraftDataReqSubmittedToVivli',
    VivliApprovedToAwaitingDataProvider = 'VivliApprovedToAwaitingDataProvider',
    VivliApprovedToAwaitingIRP = 'VivliApprovedToAwaitingIRP',
    VivliApprovedToApproved = 'VivliApprovedToApproved',
    RejectedByVivli = 'RejectedByVivli',
    ApprovedByADataProvider = 'ApprovedByADataProvider',
    RevisionsRequestedByADataProvider = 'RevisionsRequestedByADataProvider',
    RejectedByADataProvider = 'RejectedByADataProvider',
    ApprovedByAllDataProviders = 'ApprovedByAllDataProviders',
    ApprovedByAnIRP = 'ApprovedByAnIRP',
    RevisionsRequestedByAnIRP = 'RevisionsRequestedByAnIRP',
    RejectedByByAnIRP = 'RejectedByByAnIRP',
    Approved = 'Approved',
    IPDProvidedByADataProvider = 'IPDProvidedByADataProvider',
    Cancelled = 'Cancelled',
    AwaitingDUAValidation = 'AwaitingDUAValidation',
    DUAValidated = 'DUAValidated',
    DUAReturnedToRequestor = 'DUAReturnedToRequester',
    PartiallyFulfilled = 'PartiallyFulfilled',
    Fulfilled = 'Fulfilled',
    Archived = 'Archived',
    ResetToDraft = 'ResetToDraft',
    AddedDataPackages = 'AddedDataPackages',
    SafetyConcern = 'SafetyConcern',
    VMProvisioned = 'VMProvisioned',
    ResultExportRequested = 'ResultExportRequested',
    ResultExportRequestResponse = 'ResultExportRequestResponse',
    StudyDownload = 'StudyDownload',
    FirstPublication = 'FirstPublication',
    VMDeprovisioned = 'VMDeprovisioned',
    PdfVersionCreated = 'PdfVersionCreated',
}
